import { render, staticRenderFns } from "./ComponentDebug.vue?vue&type=template&id=3196b8b0&scoped=true&"
import script from "./ComponentDebug.vue?vue&type=script&lang=js&"
export * from "./ComponentDebug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196b8b0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3196b8b0')) {
      api.createRecord('3196b8b0', component.options)
    } else {
      api.reload('3196b8b0', component.options)
    }
    module.hot.accept("./ComponentDebug.vue?vue&type=template&id=3196b8b0&scoped=true&", function () {
      api.rerender('3196b8b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Utils/ComponentDebug.vue"
export default component.exports